// Details may be reached from either source in Browse all. Only return to a
// known library root, never to an arbitrary path supplied in navigation state.
export function libraryReturnPath(state, fallback) {
  const path = state?.libraryReturnTo;
  return typeof path === 'string' && /^\/(library|market)(\?[^#]*)?$/.test(path) ? path : fallback;
}
